var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00830078H513V341.992H0V-0.00830078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00830078H513V113.992H0V-0.00830078Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 227.992H513V341.992H0V227.992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.2 160.692H189.9C191.4 154.992 196.5 150.792 202.7 150.792V130.892C184.4 130.892 169.6 145.792 169.6 163.992V180.492H219.2C221 180.492 222.5 181.992 222.5 183.792V190.392H156.3V210.292H242.4V183.792C242.4 171.092 232 160.692 219.2 160.692ZM268.8 190.492V130.892H249V210.392H282.1V190.492H268.8ZM335 190.492V130.892H315.2V190.492H308.6V170.692H288.7V210.392H348.3V190.492H335Z",
    fill: "#547C31"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00830078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIq);
export default __webpack_public_path__ + "static/media/IQ.f494fb8a39f1b740726dfdba96e098b2.svg";
export { ForwardRef as ReactComponent };